// extracted by mini-css-extract-plugin
module.exports = {"cls1":"StyledComponents-IconContainer_cls1__2CuaB","cls2":"StyledComponents-IconContainer_cls2__2yGX0 StyledComponents-IconContainer_cls1__2CuaB"};